<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/10/2020
  -->

<template>
	<div class="h-vh-100 coaching-process-details-root w-100 hide-scrollbar relative">

		<div v-if="programDetailsItem" class="h-100">


			<div class="row h-100">
				<div class="col col-md-8 overflow-y h-100" style="padding-top: 20px;">
					<BackHeader @click="goBack()">
						{{ programDetailsItem ? programDetailsItem.name : "Loading..."}} <i class="fontello icon-pencil button-circle"  @click.stop="onProgramEditClicked"/>
					</BackHeader>
					<el-card class="mb-4">

						<ProgramAgenda
							ref="programAgenda"
							title="Coaching process"
							:data="programItem"
							:analytics-props="analyticsPropsMethod()"
							:clientsCount="clientArray.length"
							:hide-add-coaching-session="false"
							@change="onProgramChangedWithNotification"
							@changeSilent="onProgramChanged"
							@onItemClicked="onProgramItemClicked"
							@onSectionClicked="onSectionClicked"
							@onSectionDeleteClicked="onSectionDeleteClicked"
							@addTaskClicked="addProgramTaskClicked"
							@addCallClicked="addCallClicked"
							@addSectionClicked="addSectionClicked"
							@addSectionWithSessionClicked="addSectionWithSessionClicked"
							@addNoteClicked="addNoteClicked"
							@onAddContractClicked="onAddContractClicked"
						/>
					</el-card>
				</div>
				<div class="col col-md-4 overflow-y h-100 right-column-main">
					<el-card class="mb-4">
						<Widget
							:title="'<h5><small class=\'text-muted\'>Client:</small></h5>'"
							customHeader :collapse="!programDetailsItem.isOneOnOne()"
							:options="options"
						>
							<div v-if="hasClients">
										<span
											  v-for="client in clientArray"
											  :key="client.id"
											  :label="client.name + ' <' + client.email + '>'"
											  :value="client">

											<div class="row mx-0 align-items-center">
												<div class="pr-4 clickable"
													 @click="onClientClickedFromDialog(client)">
													<a href="#" @click.prevent>{{client.name }}</a>
															<!--<div><small class='text-muted'>{{ client.email }}</small></div>-->
													<div v-if="!client.isEnabled" class="text-muted small">
														Client disabled
														<span class="dot badge-danger"></span>
													</div>
													<ProgramInfoStatus v-else-if="isClientStatusPending(client)"
																	   :programInfo="client.getProgramInfo(programItem.id)"/>
															<!--										<hr v-if="clientArray.length > 0 && !programDetailsItem.isOneOnOne()"/>-->
												</div>
												<small v-if="canShowResendInviteButton(client)">
													<a href="#" :class="{disabled: isInviteSending}" @click.prevent.stop="onResendInviteClicked(client)" >
														<span v-if="isInviteSending"><i class="fontello icon-spin5 pr-1"/>sending...</span>
														<span v-else>Resend invite</span>
													</a>
												</small>
											</div>

										</span>


								<!--									<hr/>-->
								<ClientAccessSettingsPanel
									class="mt-4 mb-2"
									:showHeader="false"
									:analytics-props="analyticsPropsMethod()"
									v-model="programDetailsItem.clientAccessSettings"
									@change="onClientEditingSettingsChanged"/>
							</div>
						</Widget>
					</el-card>

					<el-card class="mb-4" v-if="programDetailsItem.isOneOnOne()">
						<CoachingSessionsPanel
							ref="coachingSessions"
							v-model="sessionType"
							v-bind="$attrs"
							mainRouteName="ProcessEventType"
							backRouteName="ProcessDetailsCoach"
							:programItem="programDetailsItem"
							:analytics-props="analyticsPropsMethod()"
							/>
					</el-card>

					<el-card class="mb-4" v-if="programDetailsItem.isOneOnOne()">
						<ProgramBillingPanel
							ref="programBilling"
							:data="billingData"
							:programItem="programDetailsItem"
							:invoices="invoices"
							:clients="clientArray"
							:analytics-props="analyticsPropsMethod()"
							@change="onBillingDataChanged"
							@invoiceGroupUpdated="onInvoiceGroupUpdated"/>
					</el-card>

				</div>
			</div>

		</div>

		<qw-drawer
			v-model="showClientProfileDialog">
			<ClientProfileView v-if="clickedClientProfile"
							   :clientProfile="clickedClientProfile"
							   :showEnableClientButton="true"
								@backPressed="clientProfileClose()"/>
		</qw-drawer>

		<LoadingIndicator/>

	</div>
</template>

<script>

	import BaseProgramDetails from "@/core/modules/coach/Coaching/BaseProgramDetails.vue"

	import Widget from '@/core/components/Widget/Widget.vue';
	import ProgramAgenda from '@/core/components/ProgramAgenda/ProgramAgenda.vue'
	import ProgramInfoStatus from "@/core/components/ProgramInfoStatus.vue";
	import ClientProfileView from "@/core/modules/coach/Clients/ClientProfile/ClientProfileView.vue";

	import {ProgramStatusEnum} from "@shared/Program/CoachingProgram";
	import BillingData from "@shared/Billing/BillingData";

	import {yesNoDialog} from "@/core/components/Dialogs/dialog";
	import ClientAccessSettingsPanel from "@/core/modules/coach/Coaching/Panels/ClientAccessSettingsPanel.vue";
	import BackHeader from "@/core/components/BackHeader.vue";
	import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
	import {existingSessionCoachDialog, newSessionCoachDialog} from "@/core/modules/coach/Coaching/Dialogs/dialog";
	import CoachingSessionsPanel from "@/core/modules/coach/Coaching/Panels/CoachingSessionsPanel/CoachingSessionsPanel.vue";
	import ProgramBillingPanel from "@/core/modules/coach/Coaching/Panels/ProgramBilling/ProgramBillingPanel.vue";
	import QwDrawer from "@/core/components/Form/QwoachDrawer.vue";

	import {deleteConfirmDialog, messageDialogSimple} from "@/core/components/Dialogs/dialog"


	export default {
		name: 'CoachingProcessDetails',
		extends: BaseProgramDetails,
		components: {
			QwDrawer,
			ProgramBillingPanel,
			CoachingSessionsPanel,
			LoadingIndicator,
			BackHeader,
			ClientAccessSettingsPanel,
			ProgramAgenda,
			Widget,
			ProgramInfoStatus,
			ClientProfileView
		},
		data() {
			return {
				programItem: null,
				clientList: [],
				clientProfile: null,
				isInviteSending: false,
				isClientEditingAllowed: false,
				billingData: new BillingData(),
				invoices: [],
				showClientProfileDialog: false,
				clickedClientProfile: null,
				options: {collapsed: false},
			}
		},

		methods: {



			async loadData() {
				console.log("created this")

				let programItem = await this.startListenForProgramChange()

				let [clientList, billingData, invoices] = await Promise.all([
					this.$dataManager.getClientListByProgramId(this.programId),
					this.$dataManager.getBillingDataByProgramId(this.programId),
					this.$dataManager.getInvoiceGroupsByProgramId(this.programId),
				])

				console.log("programItem = ", programItem)
				if(!programItem){
					this.goBack()
					return
				}
				if(programItem.sessionTypeId){
					this.sessionType = await this.$dataManager.apiGetEventType({sessionTypeId: programItem.sessionTypeId, coachId: this.getCoachId()})
				}

				this.clientList = clientList
				this.clientProfile = clientList[0]
				this.billingData = billingData || programItem.createBillingData()
				this.invoices = invoices
				this.programItem = programItem


				await this.ensureInvitationLink()

				let _ = this.syncFutureRecurringSessionsIfNeeded(this.programItem)
				programItem.syncPaymentLockerFromBillingData(this.billingData, this.invoices)

				let clientAccessSettings = this.programItem.clientAccessSettings
				this.isClientEditingAllowed = clientAccessSettings.canEdit

				console.log("programDetails: this.billingData = ",this.billingData)
				console.log("programDetails: this.invoices = ",this.invoices)
				this.showItemDetailsIfNeeded();
			},

			async ensureInvitationLink(){
				console.log("ensureInvitationLink")
				if(!this.programItem.inviteId && this.canShowResendInviteButton(this.clientProfile)){
					let programInvite = await this.$dataManager.getProgramInviteByProgramId(this.programItem.id)
					console.log("ensureInvitationLink: programInvite = ", programInvite)
					if(programInvite){
						this.programItem.inviteId = programInvite.id
						this.programItem.isLinkInviteEnabled = true
						await this.$dataManager.updateProgram(this.programItem)
					}
				}
			},


			async onProgramUpdatedFromServer(newProgram){
				if(this.programDetailsItem && newProgram){
					if(this.compareProgramsPaymentStatusChanged(this.programDetailsItem, newProgram)){
						this.invoices = await this.$dataManager.getInvoiceGroupsByProgramId(this.programId)
					}
				}
			},

			compareProgramsPaymentStatusChanged(program1, program2){
				console.log("compareProgramsPaymentStatusChanged: program1.programSteps = ", program1.programSteps, ", program1 = ", program1)
				for(let step1 of program1.programSteps){
					let step2 = program2.findStepById(step1.id)
					if(step2 && step2.lockerState.isLockedByPayment !== step1.lockerState.isLockedByPayment){
						console.log("compareProgramsPaymentStatusChanged: true")
						return true
					}
				}
				console.log("compareProgramsPaymentStatusChanged: false")
				return false
			},

			isClientStatusPending(client) {
				console.log("isClientStatusPending: client = ", client)
				return client.getProgramInfo(this.programItem.id).status === ProgramStatusEnum.PENDING
			},

			async goBack(){
				let _ = this.$analyticManager.trackEvent("Coaching process back clicked", this.getProgramAnalyticsData())
				await this.go('CoachingProcessMainCoach')
			},

			getProgramInfo(clientProfile){
				if(clientProfile){
					return clientProfile.programInfoByProgramId(this.programItem.id)
				}
			},

			canShowResendInviteButton(clientProfile){
				let programInfo = this.getProgramInfo(clientProfile)
				let res = !!programInfo && programInfo.isPending()
				return res
			},

			async onResendInviteClicked(clientProfile){
				await yesNoDialog({
					title: "Resend invite",
					message:`Do you want to resend invite to ${clientProfile.name} at ${clientProfile.email}?`,
					yesTitle: "Resend invite",
					onOkLoadingText: "Sending invite...",
					actionOk: () => this.sendInvitationEmail(clientProfile)
				})
			},

			async sendInvitationEmail(clientProfile){
				this.isInviteSending = true
				try{
					await this.$dataManager.apiPostResendInvite({
						clientProfileId: clientProfile.id,
						programId: this.programItem.id
					})
					this.toast("Invite resent successfully")
				} catch (error){
					this.handleError(error)
				}
				this.isInviteSending = false
			},

			assignClientToContracts(clientProfile){

				let contractsArray = this.programDetailsItem.findStepAll(programStep => programStep.isTypeContract())
				let promiseArray = contractsArray.map(contractStep => {
					if(contractStep.contract){
						let contract = contractStep.contract
						contract.assignClientFromClientProfile(clientProfile)
						return this.$dataManager.updateContract(contract)
					}
					return Promise.resolve()
				})

				return Promise.all(promiseArray)

			},


			onClientClickedFromDialog(clientProfile) {
				this.$analyticManager.trackEvent("Client clicked", {client_id: clientProfile.id, ...this.analyticsPropsMethod()})
				this.clickedClientProfile = clientProfile
				this.showClientProfileDialog = true
			},
			clientProfileClose() {
				this.$analyticManager.trackEvent("Client profile closed", {client_id: this.clickedClientProfile.id, ...this.analyticsPropsMethod()})
				this.showClientProfileDialog = false
			},

			// async onDeleteClientClicked(){
			// 	let res = await deleteConfirmDialog({
			// 		itemName: "client",
			// 		confirmActionTitle: "Remove",
			// 		additionalText: "The client will lose access to this program"
			// 	})
			// 	if(!res){
			// 		return
			// 	}
			// 	res = await this.handleAsync(this.$dataManager.apiPostRemoveClientFromProgram({
			// 		clientId: this.clickedClientProfile.id,
			// 		programId: this.programItem.id
			// 	}))
			// 	if(res){
			// 		this.clientProfileClose()
			// 		this.$router.go()
			// 	}
			// },


			onInvoiceGroupUpdated(invoiceGroup, billingView) {
				if(invoiceGroup.isPaymentStatusDeleted()){
					return this.onInvoiceDeleted(invoiceGroup, billingView)
				}
				console.log("invoiceGroup: invoiceGroup = ", invoiceGroup)
				invoiceGroup.setProgramId(this.programId)
				invoiceGroup.setTitle(this.programDetailsItem.name)
				invoiceGroup.setDetailsUrlEach(invoice => {
					let detailsUrl = this.resolvePathByRouteName("InvoicePay", {coachId: this.ownerProfile.id, invoiceGroupId: invoiceGroup.id, billToId: invoice.billTo.id})
					console.log("setDetailsUrlEach: detailsUrl = ", detailsUrl)
					return detailsUrl
				})
				let programDetailsUrl = this.resolvePathByRouteName("ProcessDetailsCoach", {programId: this.programId})
				invoiceGroup.setProgramDetailsUrl(programDetailsUrl)

				let isEmailSent = invoiceGroup.isEmailSentAll();
				invoiceGroup.setIsEmailSent(true)
				this.invoices.pushUnique(invoiceGroup, (left, right) => left.id == right.id)
				return this.progressNonBlocking()
					.for(_ => this.$server.updateInvoiceGroup(invoiceGroup))
					.then(invoice => {
						if(!isEmailSent){
							this.$message.success("Invoice sent")
							return this.$dataManager.apiPostInvoiceGroupSendEmailNotification(invoice)
						}
					}).catch(error => {
						this.invoices.deleteItem(invoiceGroup, (left, right) => left.id == right.id)
						this.handleError(error, "Can't create invoice. Please try again or contact support.")
					})
			},


			async showExistingSession(dataItem, sectionIndex){
				console.log("showExistingSession coach")
				let res = await existingSessionCoachDialog({
					programStep: dataItem,
					programItem: this.programItem,
					sessionType: this.sessionType,
					clientProfile: this.clientProfile,
					sectionIndex: sectionIndex,
					actionDelete: () => this.deleteProgramStep(dataItem)
				})

				console.log("showExistingSession coach: res = ", res)

				return res
			},

			async scheduleNewSession(dataItem, sectionIndex){
				console.log("scheduleNewSession coach")

				let res = await newSessionCoachDialog({
					programItem: this.programItem,
					programStep: dataItem,
					sessionType: this.sessionType,
					clientProfile: this.clientProfile,
					sectionIndex: sectionIndex,
					actionDelete: () => this.deleteProgramStep(dataItem)
				})

				console.log("addCallClicked: res = ", res)
				if(res){
					await this.handleAsyncNonBlocking(this.onProgramChanged())
				}
			},

			onInvoiceDeleted(invoice, billingView) {
				console.log("onInvoiceDeleted: invoice = ", invoice)
				return this.progressNonBlocking()
					.for(_ => this.$server.deleteInvoiceGroup(invoice))
					.then(invoice => {
						this.invoices.deleteItem(invoice, (left, right) => left.id == right.id)
					}).catch(error => {
						this.handleError(error, "Can't delete invoice. Please try again or contact support.")
					})
			}

		},

		computed: {
			hasClients() {
				return this.clientArray.length > 0
			},
			canShowInviteButton() {
				return !this.programDetailsItem.isOneOnOne() || !this.hasClients
			},
			clientArray(){
				return this.clientList
			}
		},



	}
</script>


<style lang="scss">
.coaching-process-details-root{
	margin-top: -20px;
	.label-width {
		width: 140px !important;
	}
	.main-content{
		height: calc(100% - 54px);
	}
	.right-column-main{
		padding-top: 74px;
	}
}


</style>




